(function() {
  'use strict';
  const menuBtn = document.getElementById('menuBtn');
  const closeMenuBtn = document.getElementById('closeMenuBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  const cartBtn = document.getElementById('cartBtn');
  const header = document.getElementById('mainHeader');
  const headerInner = document.getElementById('headerInner');

  if (menuBtn) menuBtn.addEventListener('click', () => mobileMenu?.classList.add('open'));
  if (closeMenuBtn) closeMenuBtn.addEventListener('click', () => { mobileMenu?.classList.remove('open'); });

  /* Cart: event delegation - cartBtn her zaman tıklanabilir (header'da, değişmez) */
  document.body.addEventListener('click', function(e) {
    const btn = e.target.closest('#cartBtn');
    if (btn) {
      e.preventDefault();
      const drawer = document.getElementById('cartDrawer');
      const overlay = document.getElementById('cartOverlay');
      if (drawer && overlay) {
        drawer.classList.add('open');
        overlay.classList.add('open');
      }
    }
  });

  function closeCartDrawer() {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }

  /* Search drawer */
  const searchBtn = document.getElementById('searchBtn');
  const searchDrawer = document.getElementById('searchDrawer');
  const searchOverlay = document.getElementById('searchOverlay');
  const closeSearchBtn = document.getElementById('closeSearchBtn');
  const searchDrawerInput = document.getElementById('searchDrawerInput');
  const searchDrawerForm = document.getElementById('searchDrawerForm');
  const searchDrawerResults = document.getElementById('searchDrawerResults');
  let searchDebounce = null;

  function openSearch() {
    searchDrawer?.classList.add('open');
    searchOverlay?.classList.add('open');
    searchOverlay?.setAttribute('aria-hidden', 'false');
    setTimeout(() => searchDrawerInput?.focus(), 100);
  }
  function closeSearch() {
    searchDrawer?.classList.remove('open');
    searchOverlay?.classList.remove('open');
    searchOverlay?.setAttribute('aria-hidden', 'true');
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (closeSearchBtn) closeSearchBtn.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchDrawer?.classList.contains('open')) closeSearch();
  });

  if (searchDrawerForm) {
    searchDrawerForm.addEventListener('submit', function(e) {
      const q = searchDrawerInput?.value?.trim();
      if (!q) { e.preventDefault(); return; }
    });
  }

  if (searchDrawerInput && searchDrawerResults) {
    searchDrawerInput.addEventListener('input', function() {
      const q = this.value.trim();
      clearTimeout(searchDebounce);
      if (q.length < 2) {
        searchDrawerResults.innerHTML = '<p class="search-drawer-hint">Aramak için en az 2 karakter yazın</p>';
        return;
      }
      searchDebounce = setTimeout(() => {
        searchDrawerResults.innerHTML = '<p class="search-loading">Aranıyor...</p>';
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[limit_scope]=each')
          .then(r => r.json())
          .then(data => {
            const products = data.resources?.results?.products || [];
            if (products.length === 0) {
              searchDrawerResults.innerHTML = '<p class="search-no-results">Sonuç bulunamadı. Enter ile tüm aramaya gidin.</p>';
              return;
            }
            let html = '';
            products.forEach(p => {
              const img = p.image || p.featured_image || '';
              const imgUrl = img ? (String(img).startsWith('//') ? 'https:' + img : img) : '';
              const title = (p.title || '').replace(/</g, '&lt;').replace(/"/g, '&quot;');
              const url = p.url || '/search?q=' + encodeURIComponent(q);
              html += '<a href="' + url + '" class="search-product"><img src="' + imgUrl + '" alt="" class="search-product-img" width="64" height="64" loading="lazy"><div class="search-product-info"><p class="search-product-title">' + title + '</p><p class="search-product-price">' + (p.price || '') + '</p></div></a>';
            });
            html += '<p class="search-drawer-hint" style="margin-top:16px"><a href="/search?type=product&q=' + encodeURIComponent(q) + '">Tüm sonuçları gör</a></p>';
            searchDrawerResults.innerHTML = html;
          })
          .catch(() => {
            searchDrawerResults.innerHTML = '<p class="search-no-results">Arama yapılamadı. Enter ile deneyin.</p>';
          });
      }, 300);
    });
  }

  document.querySelectorAll('.footer-accordion').forEach(btn => {
    btn.addEventListener('click', () => {
      const links = btn.nextElementSibling;
      if (!links || !links.classList.contains('footer-links')) return;
      const isOpen = links.classList.toggle('open');
      btn.classList.toggle('is-open', isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  /* Sticky header: histerezis — yükseklik değişince scrollY sınırda kalıp sınıfı sürekli açıp kapatmayı önler */
  if (header) {
    var SCROLL_ADD = 64;
    var SCROLL_REMOVE = 24;
    var headerScrolled = false;
    var headerScrollTicking = false;

    function applyHeaderScrolled() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (!headerScrolled && y > SCROLL_ADD) {
        headerScrolled = true;
        header.classList.add('scrolled');
        headerInner?.classList.add('scrolled');
      } else if (headerScrolled && y < SCROLL_REMOVE) {
        headerScrolled = false;
        header.classList.remove('scrolled');
        headerInner?.classList.remove('scrolled');
      }
    }

    function onHeaderScroll() {
      if (!headerScrollTicking) {
        headerScrollTicking = true;
        requestAnimationFrame(function() {
          applyHeaderScrolled();
          headerScrollTicking = false;
        });
      }
    }

    applyHeaderScrolled();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
  }

  /* About page animations */
  const pageAbout = document.querySelector('.page-about-react');
  if (pageAbout) {
    const heroAnims = pageAbout.querySelectorAll('.about-anim');
    heroAnims.forEach((el) => {
      const delay = parseInt(el.dataset.delay || 0, 10);
      setTimeout(() => el.classList.add('animated'), 50 + delay);
    });
    const scrollAnims = pageAbout.querySelectorAll('.about-scroll-anim');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const delay = parseInt(el.dataset.delay || 0, 10);
          setTimeout(() => el.classList.add('in-view'), delay);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    scrollAnims.forEach(el => observer.observe(el));
  }

  function refreshCartDrawer(keepOpen) {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    const wasOpen = keepOpen || (drawer?.classList.contains('open') && overlay?.classList.contains('open'));

    fetch('/?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('[id*="shopify-section-cart-drawer"]') || doc.querySelector('.cart-drawer')?.parentElement;
        const currentSection = document.querySelector('[id*="shopify-section-cart-drawer"]');
        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
          initCartDrawerEvents();
          if (wasOpen) {
            const newDrawer = document.getElementById('cartDrawer');
            const newOverlay = document.getElementById('cartOverlay');
            if (newDrawer) newDrawer.classList.add('open');
            if (newOverlay) newOverlay.classList.add('open');
          }
        }
        return fetch('/cart.js').then(r => r.json());
      })
      .then(cart => {
        const countEl = document.getElementById('cartCount');
        if (countEl) {
          countEl.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
        }
      })
      .catch(() => {});
  }

  /* Mini sepet: “Ödeme Yap” — Liquid’den gelen checkout URL (href* seçicisi /cart linklerinde eşleşmiyordu) */
  document.body.addEventListener('click', function(e) {
    var link = e.target.closest && e.target.closest('#cartDrawer a[data-mini-cart-checkout]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    var url = link.getAttribute('data-checkout-href') || link.getAttribute('href');
    if (url) window.location.assign(url);
  }, true);

  function initCartDrawerEvents() {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    document.getElementById('closeCartBtn')?.addEventListener('click', closeCartDrawer);
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    drawer?.querySelectorAll('.qty-control [data-action]').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.getAttribute('data-key');
        const row = this.closest('.cart-item');
        const span = row?.querySelector('.qty-control span');
        let qty = parseInt(span?.textContent || 1);
        if (this.getAttribute('data-action') === 'plus') qty++; else if (qty > 1) qty--;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(r => r.json()).then(r => { if (!r.error) refreshCartDrawer(true); else alert(r.description); });
      });
    });
    drawer?.querySelectorAll('.remove-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: this.getAttribute('data-key'), quantity: 0 }) })
          .then(r => r.json()).then(r => { if (!r.error) refreshCartDrawer(true); else alert(r.description); });
      });
    });
  }

  initCartDrawerEvents();

  function syncProductFormBeforeAdd(form) {
    const qtyInput = form.querySelector('#QuantityInput') || form.querySelector('[name="quantity"]');
    const qtyValue = form.querySelector('.qty-value');
    if (qtyInput && qtyValue) qtyInput.value = String(parseInt(qtyValue.textContent, 10) || 1);
    const selected = form.querySelector('.purchase-options .option-row.selected');
    const planInput = form.querySelector('#SellingPlanInput');
    if (planInput && selected) {
      const planId = selected.getAttribute('data-selling-plan-id') || '';
      if (planId) {
        planInput.disabled = false;
        planInput.value = planId;
      } else {
        planInput.value = '';
        planInput.disabled = true;
      }
    }
  }

  document.body.addEventListener('submit', function(e) {
    const form = e.target.closest && e.target.closest('form.add-to-cart-form');
    if (!form) return;
    e.preventDefault();
    syncProductFormBeforeAdd(form);
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(r) {
        return r.json().then(function(data) {
          return { ok: r.ok, status: r.status, data: data };
        });
      })
      .then(function(res) {
        if (!res.ok || (res.data && res.data.status && res.data.status >= 400)) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Ürün sepete eklenemedi.';
          alert(msg);
          return;
        }
        refreshCartDrawer(true);
      })
      .catch(function() {
        alert('Bir hata oluştu.');
      });
  });
})();
